import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Page } from '../../../model/page';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import { permissions } from '../../../permissions';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
} from '@angular/router';
import { AuthService } from '../../../auth/auth.service';
import { tableCols, newOrderTableCols, altOldTableCols, altTableCols } from './scanned-data.cols';
import { ToastrService } from 'ngx-toastr';
import { ScannedDataService } from '../services/scanned-data.service';
import { ExportModalComponent } from '../../../components/export-modal';
import { MatDialog } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { ConfirmationService } from 'primeng/api';
import { MatDatepickerInputEvent } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { LocalDatePipe } from '../../pipes/local-date.pipe';
import { DisplayFieldPipe } from '../../pipes/displayField.pipe';
import { CurrencyPipe } from '@angular/common';
import { TableExtensionService } from '../table-extension.service';
import {fiveDecCompanies} from '../../../../environments/environment';

@Component({
  selector: 'app-scanned-data',
  templateUrl: './scanned-data.component.html',
  styleUrls: ['./scanned-data.component.scss'],
  providers: [AuthService, ScannedDataService, TableExtensionService],
  encapsulation: ViewEncapsulation.None,
})
export class ScannedDataComponent implements OnInit, OnDestroy {
  public permissions = permissions;

  @ViewChild('dataView') dataView: ElementRef;
  @ViewChild('actionbar') actionbar: ElementRef;
  @ViewChild('tableHeader') tableHeader: ElementRef;
  @ViewChild('tableFilter') tableFilter: ElementRef;
  @ViewChild('paginator') paginator: ElementRef;

  @Input() MD1_ID = null;
  @Input() mirrorUrl = null;
  public partialRender: boolean;

  public page = new Page();
  public rows: Array<any>;
  public tooltipRows: Array<any>;
  cols = [];
  exportCols = [];
  totalRecords = 0;
  size = 50;
  hideTooltip = false;

  private selected: Array<any>;
  private viewFilters = false;
  private loading = false;
  public userActionLoading: boolean;
  public isWorkspaceSelected: boolean;
  public filtersApplied = false;

  public screenTitle: string;
  public mode: string;
  public editEnable: boolean;
  public resendEnable: boolean;

  public fromDateFilter: any;
  public toDateFilter: any;

  // private dialogContentHeight = '150px';
  public scrollHeight = '50px';
  private viewportHeight = 0;
  private viewportHeightListener: boolean;

  private subscription: Subscription;

  public uploadFlagOptions: Array<object>;
  private scannedDataServiceRef = ScannedDataService;

  constructor(
    private scannedDataService: ScannedDataService,
    private authService: AuthService,
    private toast: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private title: Title,
    private confirmationService: ConfirmationService,
    private localDatePipe: LocalDatePipe,
    private displayFieldPipe: DisplayFieldPipe,
    private currencyPipe: CurrencyPipe,
    private tableExtensionService: TableExtensionService
  ) {
    this.page.pageNumber = 0;
    this.page.size = 50;
  }

  ngOnInit() {
    this.isWorkspaceSelected = this.getSelectedWorkspace();
    this.initValues();

    this.partialRender = this.MD1_ID !== null;
    if (this.partialRender && this.mirrorUrl != null) {
      this.parseUrl(this.mirrorUrl);
    } else {
      const coreUrl =
        '/' +
        this.route.snapshot.url[0].toString() +
        '/' +
        this.route.snapshot.url[1].toString();
      this.parseUrl(coreUrl);
    }
    if (!this.partialRender) {
      this.title.setTitle('OES - ' + this.screenTitle);
    }

    const filterParams = this.route.snapshot.queryParams;
    this.parseParams(filterParams);

    if (this.isWorkspaceSelected) {
      this.getData(false);
      this.screenHeightListener();
    }

    this.setExtraCols();
  }

  ngOnDestroy() {
    this.viewportHeightListener = false;
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private initValues() {
    this.userActionLoading = false;
    this.selected = [];
    this.rows = [];
    this.tooltipRows = [];

    if (this.authService.permissions.includes('VIEW_PRICING_INFO')) {
      this.cols = newOrderTableCols;
      this.exportCols = tableCols;
    } else {
      this.cols = altTableCols;
      this.exportCols = altOldTableCols;
    }
    this.editEnable = false;
    this.resendEnable = false;
    this.fromDateFilter = '';
    this.toDateFilter = '';

    this.viewportHeightListener = true;
  }

  private parseUrl(url: string) {
    if (url === this.scannedDataServiceRef.MIRROR_URL_SD2) {
      this.screenTitle = this.scannedDataServiceRef.LABEL_SD2;
      this.mode = this.scannedDataServiceRef.MODE_SD2;
      this.uploadFlagOptions =
        this.scannedDataService.getConsumptionDataUploadFlags();
    } else if (url === this.scannedDataServiceRef.MIRROR_URL_SD3) {
      this.screenTitle = this.scannedDataServiceRef.LABEL_SD3;
      this.mode = this.scannedDataServiceRef.MODE_SD3;
      this.uploadFlagOptions =
        this.scannedDataService.getReceivingDataUploadFlags();
    } else {
      this.screenTitle = this.scannedDataServiceRef.LABEL_SD1;
      this.mode = this.scannedDataServiceRef.MODE_SD1;
      this.uploadFlagOptions =
        this.scannedDataService.getScannedDataUploadFlags();
      this.editEnable = true;
      this.resendEnable = true;
    }
  }

  private parseParams(filterParams) {
    if (filterParams !== undefined && filterParams !== null) {
      let showFilters = false;
      for (const key of Object.keys(filterParams)) {
        let value = filterParams[key];
        if (value && value.toString() !== '') {
          if (key.toString() === 'UPLOAD') {
            value = Number(value);
          }

          if (key.toString() === 'page') {
            this.page.pageNumber = Number(value);
          } else if (key.toString() === 'perPage') {
            this.page.size = Number(value);
            this.size = Number(value);
          } else if (key.toString() === 'mode') {
            this.page.filterParams[key] = value;
          } else {
            this.page.filterParams[key] = value;
            showFilters = true;
          }

          if (key.toString() === 'FROM_DATE') {
            this.fromDateFilter = this.getDateFromString(value.toString());
          }
          if (key.toString() === 'TO_DATE') {
            this.toDateFilter = this.getDateFromString(value.toString());
          }
        }
      }
      this.viewFilters = showFilters;
      this.filtersApplied = showFilters;
    }
  }

  getData(reloadWithParams = true) {
    this.setPage({ offset: this.page.pageNumber }, reloadWithParams);
  }

  setPage(pageInfo, reloadWithParams = true) {
    if (reloadWithParams && !this.partialRender) {
      this.page.filterParams['page'] = pageInfo.offset ? pageInfo.offset : 0;
      this.page.filterParams['perPage'] = pageInfo.size
        ? pageInfo.size
        : this.size;
      this.router.routeReuseStrategy.shouldReuseRoute = function (
        future: ActivatedRouteSnapshot,
        curr: ActivatedRouteSnapshot
      ) {
        return false;
      };
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: this.page.filterParams,
      });
    } else {
      this.loading = true;
      this.selected = [];
      this.rows = [];
      this.tooltipRows = [];
      this.page.pageNumber = pageInfo.offset ? pageInfo.offset : 0;
      this.page.size = pageInfo.size ? pageInfo.size : this.size;
      this.size = pageInfo.size ? pageInfo.size : this.size;

      if (this.partialRender) {
        this.page.filterParams['MD1_ID'] = this.MD1_ID;
      }
      this.page.filterParams['mode'] = this.mode;
      this.subscription = this.scannedDataService
        .getDataList(this.page)
        .subscribe(
          (result) => {
            this.totalRecords = result.count;
            this.page.totalPages = result.count / this.page.size;
            this.rows = result.data;
            this.tooltipRows = this.getTooltipTextArray();
            window.scroll(0, 0);
            this.loading = false;
          },
          () => {
            this.loading = false;
            window.dispatchEvent(new Event('resize'));
            this.toast.error('Request timed out.', 'Service Error', {
              timeOut: 3000,
            });
          }
        );
    }
  }

  buttonPress(e, col, value) {
    if (e.keyCode === 13) {
      this.filterChanged(col, value);
    }
  }

  clearFilters() {
    this.page.filterParams = {};
    this.viewFilters = false;
    this.filtersApplied = false;
    this.page.pageNumber = 0;
    this.setPage({ offset: this.page.pageNumber });
  }

  clearFromDate() {
    this.fromDateFilter = '';
    this.filterChanged('FROM_DATE', '');
  }

  clearToDate() {
    this.toDateFilter = '';
    this.filterChanged('TO_DATE', '');
  }

  filterChanged(col, value) {
    this.loading = true;
    if (
      ((col === 'ORDERED_ON' ||
        col === 'COMPLETED_ON' ||
        col === 'MODIFIED_ON' ||
        col === 'CREATED_ON') &&
        value === '01-01-1970') ||
      value === ''
    ) {
      delete this.page.filterParams[col];
    } else {
      this.page.filterParams[col] = value;
    }
    this.filtersApplied = Object.keys(this.page.filterParams).length > 1; // mode filter will persist on this page
    this.page.pageNumber = 0;
    this.setPage({ offset: this.page.pageNumber });
  }

  getContentDialogHeight(): number {
    // 77 for header & footer
    return (
      window.innerHeight -
      ((this.actionbar ? this.actionbar.nativeElement.offsetHeight : 0) + 48) -
      77
    );
  }

  getScrollHeight(): number {
    return (
      this.getContentDialogHeight() -
      (this.tableHeader.nativeElement.offsetHeight +
        (this.paginator.nativeElement.offsetHeight + 55) +
        (this.viewFilters && this.tableFilter
          ? this.tableFilter.nativeElement.offsetHeight
          : 0))
    );
  }

  getSelectedWorkspace() {
    return this.authService.workspaceMasterCustomerID !== null;
  }

  exportClick() {
    if (this.rows.length > 0 && !this.partialRender) {
      const dialogRef = this.dialog.open(ExportModalComponent, {
        width: window.innerWidth - 100 + 'px',
        height: window.innerHeight - 80 + 'px',
        role: 'dialog',
        data: {
          cols: this.exportCols,
          modeEnabled: 0,
          screenTitle: this.screenTitle,
        },
      });

      dialogRef.beforeClose().subscribe((preferences) => {
        if (preferences) {
          preferences['exportMode'] = preferences['mode'];
          this.page.filterParams['mode'] = this.mode;
          this.userActionLoading = true;
          this.scannedDataService.export(preferences, this.page).subscribe(
            (result) => {
              if (result.success) {
                this.toast.info(
                  'Export is added to queue.' +
                    ' Please check the File Exports to download the file once it is ready!',
                  'Update'
                );
              } else {
                this.toast.error('Error in exporting data.', 'Error', {
                  timeOut: 3000,
                  tapToDismiss: true,
                });
              }
              this.userActionLoading = false;
              this.loading = false;
            },
            () => {
              this.toast.error('Export request timed out.', 'Service Error');
              this.userActionLoading = false;
              this.loading = false;
            }
          );
        }
      });
    } else {
      this.toast.error('No data to export', 'Error');
    }
  }

  getDateAsString(event: MatDatepickerInputEvent<any>) {
    const date: Date = event.target.value;
    return (
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    );
  }

  getDateFromString(dateString: string): Date | null {
    let date = new Date(dateString);
    if (date.toString() === 'Invalid Date') {
      const split = dateString.split('-');
      if (split.length === 3) {
        date = new Date(
          Number(split[0]),
          Number(split[1]) - 1,
          Number(split[2])
        );
      }
    }
    if (date.toString() === 'Invalid Date') {
      date = null;
    }
    return date;
  }

  onChangeFromDate(event: MatDatepickerInputEvent<any>) {
    this.filterChanged('FROM_DATE', this.getDateAsString(event));
  }

  onChangeToDate(event: MatDatepickerInputEvent<any>) {
    this.filterChanged('TO_DATE', this.getDateAsString(event));
  }

  onPage(event) {
    this.setPage({
      offset: event.first / event.rows,
      size: event.rows,
    });
  }

  onColumnResize(event) {
    this.tableExtensionService.onColumnResize(this.cols, event);
  }

  onEdit() {
    if (!this.partialRender) {
      if (this.selected.length === 1) {
        this.router.navigate([
          'order-entry-system/' +
            this.scannedDataService.getNavigationUrl(this.mode) +
            '/edit/' +
            this.selected[0]['ID'],
        ]);
      }
    }
  }

  onView(rowData) {
    if (!this.partialRender) {
      this.router.navigate([
        'order-entry-system/' +
          this.scannedDataService.getNavigationUrl(this.mode) +
          '/view/' +
          rowData['ID'],
      ]);
    }
  }

  onResend() {
    if (!this.partialRender) {
      if (this.selected.length > 0) {
        this.confirmationService.confirm({
          header: 'Resend ' + this.screenTitle + ' records',
          message:
            'Are you sure to resend the selected ' +
            this.selected.length +
            ' record' +
            (this.selected.length > 1 ? 's' : '') +
            '?',
          accept: () => {
            this.loading = true;
            this.userActionLoading = true;
            const SD1_IDs = this.selected.map((selectedRow) => {
              return Number(selectedRow['ID']).toString();
            });
            this.scannedDataService.resend(SD1_IDs).subscribe(
              (result) => {
                this.loading = false;
                this.userActionLoading = false;
                if (
                  result.hasOwnProperty('success') &&
                  result.hasOwnProperty('errors') &&
                  result.hasOwnProperty('details')
                ) {
                  if (result.success) {
                    const sCount = Number(result.details['successCount']);
                    this.toast.success(
                      sCount.toString() +
                        ' record' +
                        (sCount > 1 ? 's' : '') +
                        ' queued for resending.'
                    );
                    this.getData(false);
                  } else {
                    this.toast.error(result.errors[0]);
                  }
                } else {
                  this.toast.error(
                    'Unexpected error encountered in processing request.'
                  );
                }
              },
              () => {
                this.loading = false;
                this.userActionLoading = false;
                this.toast.error('Request timed out.', 'Service Error');
              }
            );
          },
        });
      }
    }
  }

  onDelete() {
    if (!this.partialRender) {
      if (this.selected.length === 1) {
        const selectedRecord = this.selected[0];
        this.confirmationService.confirm({
          header: 'Delete ' + this.screenTitle + ' entry',
          message:
            'Are you sure to delete selected record?<br>' +
            '(' +
            'Bin ID: ' +
            (selectedRecord['CONTRACT_BIN_ID'] !== ''
              ? selectedRecord['CONTRACT_BIN_ID']
              : '-') +
            ', ' +
            'Item ID: ' +
            selectedRecord['ITEM_ID'] +
            ', ' +
            'Qty: ' +
            selectedRecord['QUANTITY'] +
            (selectedRecord['PO_NUMBER'] !== ''
              ? ', ' + 'PO Number: ' + selectedRecord['PO_NUMBER']
              : '') +
            (selectedRecord['JOB_NUMBER'] !== ''
              ? ', ' + 'Job Number: ' + selectedRecord['JOB_NUMBER']
              : '') +
            ')',
          accept: () => {
            this.loading = true;
            this.scannedDataService
              .delete(Number(selectedRecord['ID']), this.mode)
              .subscribe(
                (result) => {
                  if (result.success) {
                    this.toast.info('Record deleted.', 'Update');
                  } else {
                    this.toast.error('Failed to delete record.', 'Error');
                  }
                  this.getData(false);
                },
                () => {
                  this.loading = false;
                  this.toast.error('Request timed out.', 'Service Error');
                }
              );
          },
        });
      }
    }
  }

  onWindowResize() {
    setTimeout(() => {
      this.scrollHeight = this.getScrollHeight() + 'px';
      window.dispatchEvent(new Event('resize'));
    }, 150);
  }

  refreshClick() {
    this.getData(false);
  }

  screenHeightListener() {
    if (!this.viewportHeightListener) {
      return;
    }
    if (window.innerHeight !== this.viewportHeight) {
      this.viewportHeight = window.innerHeight;
      this.onWindowResize();
    }
    setTimeout(() => {
      this.screenHeightListener();
    }, 500);
  }

  toggleFilterView() {
    this.viewFilters = !this.viewFilters;
    this.onWindowResize();
  }

  onHover(e) {
    const aux = e.target.offsetWidth < e.target.scrollWidth;
    this.hideTooltip = !aux;
  }

  getTooltipTextArray() {
    this.rows.forEach((element) => {
      const newObj = Object.assign({}, element);

      newObj['DATE'] = newObj['DATE']
        ? this.localDatePipe.transform(
            newObj['DATE'],
            'MMM dd, yyyy hh:mm:ss a'
          )
        : '-';

      newObj['MD1_PRICE'] = this.currencyPipe.transform(
        newObj['MD1_PRICE'],
        'USD',
        'symbol'
      );

      newObj['TOTAL_PRICE'] = this.currencyPipe.transform(
        newObj['TOTAL_PRICE'],
        'USD',
        'symbol'
      );

      newObj['MODIFIED_ON'] =
        newObj['MODIFIED_BY_NAME'] +
        'at' +
        (newObj['MODIFIED_ON'] = this.localDatePipe.transform(
          newObj['DATE'],
          'MMM dd, yyyy hh:mm:ss a'
        ));

      newObj['UPLOAD'] = this.displayFieldPipe.transform(
        newObj['UPLOAD'],
        'value',
        'text',
        this.uploadFlagOptions
      );

      this.tooltipRows.push(newObj);
    }, this);
    return this.tooltipRows;
  }

  setExtraCols() {
    const col = this.cols.find(function (col) {
      return col.field === 'SD1_QUOTE';
    });

    const exportCol = this.exportCols.find(function (col) {
      return col.field === 'SD1_QUOTE';
    });

    if (this.mode === this.scannedDataServiceRef.MODE_SD1) {
      col.visible = true;
      exportCol.export.visible = true;
    } else {
      col.visible = false;
      exportCol.export.visible = false;
    }
  }

    protected readonly fiveDecCompanies = fiveDecCompanies;
  protected readonly parseInt = parseInt;
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/scanned-data/scanned-data.component.ts